import { AuthProvider } from "../contexts/AuthContext";
import { PageNameProvider } from "../contexts/PageTitleContext";
import { Outlet } from "react-router-dom";

/**
 * Wrapper component that provides context providers for public routes.
 */
export default function PublicLayout() {
  return (
    <PageNameProvider>
      <Outlet />
    </PageNameProvider>
  );
}

